import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="transparent"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M7.50033 10H12.5003M7.50033 13.3333H12.5003M14.167 17.5H5.83366C4.91318 17.5 4.16699 16.7538 4.16699 15.8333V4.16667C4.16699 3.24619 4.91318 2.5 5.83366 2.5H10.4885C10.7095 2.5 10.9215 2.5878 11.0777 2.74408L15.5896 7.25592C15.7459 7.4122 15.8337 7.62416 15.8337 7.84518V15.8333C15.8337 16.7538 15.0875 17.5 14.167 17.5Z" />
  </svg>
);
